import { type CompanyAccountingTermUpsertInput, CompanyAccountingType } from "@/graphql/codegen/graphql"
import type { PaymentTermsFormValues } from "@/screens/CompanySettings/Accounting/schemas/PaymentTermsSchema"
import type { TreeNode } from "@/types/tree"

export const serializeUpsertInput = (
  formValues: PaymentTermsFormValues,
  isVendor: boolean,
  isCustomer: boolean
): CompanyAccountingTermUpsertInput[] => {
  const inputs: CompanyAccountingTermUpsertInput[] = []

  // Create/update VENDOR accounting term if company is a vendor
  if (isVendor) {
    inputs.push({
      companyId: formValues.companyId,
      companyType: CompanyAccountingType.Vendor,
      paymentTermId: formValues.paymentTermIdVendor || null,
      creditLimit: formValues.creditLimitVendor?.length ? parseFloat(formValues.creditLimitVendor) : null,
    })
  }

  // Create/update CUSTOMER accounting term if company is a customer
  if (isCustomer) {
    inputs.push({
      companyId: formValues.companyId,
      companyType: CompanyAccountingType.Customer,
      paymentTermId: formValues.paymentTermIdCustomer || null,
      creditLimit: formValues.creditLimitCustomer?.length ? parseFloat(formValues.creditLimitCustomer) : null,
    })
  }

  return inputs
}

export const extractChildrenIds = (nodes: TreeNode<string>[], targetTypes: string[]): string[] => {
  const ids: string[] = []

  const traverse = (node: TreeNode<string>) => {
    // If this node is of target type (VENDOR or CUSTOMER), add its ID and all children IDs
    if (targetTypes.includes(node.id)) {
      ids.push(node.id)
      // Recursively add all children IDs
      const addAllChildrenIds = (childNode: TreeNode<string>) => {
        ids.push(childNode.id)
        childNode.children.forEach(addAllChildrenIds)
      }
      node.children.forEach(addAllChildrenIds)
    }

    // Continue traversing children regardless to find nested VENDOR/CUSTOMER nodes
    node.children.forEach(traverse)
  }

  nodes.forEach(traverse)
  return [...new Set(ids)] // Remove duplicates
}
